import { Heading, Link } from '@primer/react';
import * as React from 'react';
export default {
  Heading,
  Link,
  React
};